<template>
  <div
    v-if="expiryDate"
    :class="{
      [$style.blueContainer]: !isExpired,
      [$style.redContainer]: isExpired,
    }"
  >
    <TimerIcon :class="$style.timerIcon" />
    {{ expiryDateDisplay }}
  </div>
</template>

<script>
import { get } from 'lodash';
import TimerIcon from 'public/img/icons/timer.svg?inline';
import moment from 'moment';

export default {
  name: 'DirectoryTokenStatus',

  components: {
    TimerIcon,
  },

  props: {
    item: {
      default: () => ({}),
      type: Object,
    },
  },

  computed: {
    expiryDate() {
      const seconds = get(this.item, 'oAuthStatus.expiry.seconds', null);
      return seconds ? moment.unix(seconds) : null;
    },

    expiryDateDisplay() {
      if (this.expiryDate) {
        if (this.isExpired) {
          return 'Token expired';
        }

        return `Token expires ${this.expiryDate.utc().format('LLL')} (UTC)`;
      }

      return null;
    },

    isExpired() {
      return this.expiryDate ? this.expiryDate.isBefore() : false;
    },
  },
};
</script>

<style module>
.container {
  border-radius: 4px;
  display: inline-block;
  font-size: 11px;
  line-height: 1rem;
  padding: 0.4em 1.2em;
}

.blueContainer {
  composes: container;
  background-color: #cce2ee;
}

.redContainer {
  composes: container;
  background-color: #fadadc;
}

.timerIcon {
  height: 11px;
  margin-right: 7px;
  vertical-align: top;
  width: 11px;
}
</style>
